import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import { SectionTitle } from "./SectionTitle";

export default function Featured() {
  const items = mangaList.filter((m) => m.category === "guide").slice(0, 3);

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="SEASON GUIDE"
          title="本季新番导视"
          desc="新番导视抢先看，当季值得追的作品一目了然。"
          to="/guide"
          linkText="查看全部导视"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {items.map((m, i) => (
            <Link
              key={m.id}
              to={`/article/${m.id}`}
              className={`group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:shadow-soft ${
                i === 0 ? "md:flex-row md:col-span-2 md:row-span-1" : ""
              }`}
            >
              <div
                className={`relative overflow-hidden bg-background-200 ${
                  i === 0 ? "aspect-[16/9] w-full md:aspect-auto md:w-1/2" : "aspect-[16/9] w-full"
                }`}
              >
                <img
                  src={m.cover}
                  alt={`${m.title} 新番导视`}
                  className="h-full w-full object-cover object-top transition duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                  当季重点
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-xl text-foreground-900 md:text-2xl">
                  {m.title}
                </h3>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {m.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <p className="mt-3 line-clamp-2 flex-1 text-sm leading-6 text-foreground-600">
                  {m.synopsis}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-refresh-line"></i>
                    {m.update}
                  </span>
                  <span className="flex items-center gap-1 text-sm font-bold text-accent-600">
                    <i className="ri-star-fill"></i>
                    {m.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}